var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { Prop, Component, Mixins } from 'vue-property-decorator';
import FileUpload from 'vue-upload-component';
import { Notification } from '@/common/services/notificationService';
import { AttachmentSettings } from "@/common/types/AttachmentSettings";
import { Savable } from '@/common/mixins/Savable';
import { csrfToken, csrfTokenValue } from '@/common/utils/securityUtilities';
/*
 * Notes about multifile support
 * - Currently, this component can be used to select a single file. VueFileUpload component ('file-upload')
 *   supports selecting multiple files by setting :multiple to 'true'.
 *
 * - When implementing multifile support. Review the following:
 *    currentFile getter and setter
 *    value property
 *    deleteAttachment method
 *    all other methods which emit value back to parent
 *
 * - Additionally, you will probably want some logic for generating rows into the UI. That logic does not
 *   belong here! Instead see if you can hook onto the component events and use them to generate the UI rows
 *   you need.
 * */
var AttachmentControl = /** @class */ (function (_super) {
    __extends(AttachmentControl, _super);
    function AttachmentControl() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.focused = false;
        _this.files = [];
        return _this;
    }
    AttachmentControl.prototype.getHeaders = function () {
        var headers = {};
        headers[csrfToken] = csrfTokenValue();
        return headers;
    };
    AttachmentControl.prototype.setFocused = function (value) {
        this.focused = value;
    };
    Object.defineProperty(AttachmentControl.prototype, "validExtensions", {
        // settings
        get: function () {
            if (this.allowedExtensions && this.allowedExtensions.length > 0) {
                return this.allowedExtensions;
            }
            else {
                return this.settings.validExtensions;
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AttachmentControl.prototype, "allowedCharactersRegex", {
        get: function () {
            return this.settings.allowedCharactersRegex;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AttachmentControl.prototype, "maxSize", {
        get: function () {
            return this.settings.maxSize;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AttachmentControl.prototype, "action", {
        get: function () {
            return this.settings.action;
        },
        enumerable: false,
        configurable: true
    });
    // /settings
    AttachmentControl.prototype.mounted = function () {
        return __awaiter(this, void 0, void 0, function () {
            var fileNameWithExtension;
            return __generator(this, function (_a) {
                fileNameWithExtension = this.value;
                if (fileNameWithExtension) {
                    this.files.push(fileNameWithExtension);
                }
                return [2 /*return*/];
            });
        });
    };
    Object.defineProperty(AttachmentControl.prototype, "currentFile", {
        get: function () {
            return this.value;
        },
        set: function (value) {
            this.$emit('input', value);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AttachmentControl.prototype, "hasFile", {
        get: function () {
            return this.files.length > 0;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AttachmentControl.prototype, "validTypesFilter", {
        get: function () {
            if (this.validExtensions != null)
                return this.validExtensions.join(",");
            else
                return "";
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AttachmentControl.prototype, "acceptedExtensions", {
        // Array of extensions without leading . character. The VueFileUpload component wants extension this way.
        get: function () {
            if (this.validExtensions != null)
                return this.validExtensions.map(function (ext) { return ext.substring(1); });
            else
                return [];
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AttachmentControl.prototype, "uploadComponent", {
        get: function () {
            return this.$refs.upload;
        },
        enumerable: false,
        configurable: true
    });
    AttachmentControl.prototype.inputFilter = function (newFile, oldFile, prevent) {
        // On file insert, this is run first.
        //  Add filtering logic here and call prevent() to prevent the file operation
        //  e.g. prevent the file from being sent to the server
        var extension = this.getFileExtension(newFile);
        if (!this.validateFileType(extension)) {
            var error = this.$t("Attachment.ErrorExtension");
            Notification.error(this, error + " " + extension);
            prevent();
        }
        var name = this.getFileName(newFile);
        if (!this.validateFileNameExists(name)) {
            var error = this.$t("Attachment.ErrorNoFileName");
            Notification.error(this, error);
            prevent();
        }
        if (!this.validateFileSize(newFile)) {
            var error = this.$t("Attachment.ErrorSize");
            Notification.error(this, error + " " + this.settings.maxSizeInMB + "MB");
            prevent();
        }
    };
    AttachmentControl.prototype.getFileExtension = function (file) {
        return file.name.slice(file.name.lastIndexOf(".")).toLowerCase();
    };
    AttachmentControl.prototype.getFileName = function (file) {
        return file.name.substring(0, file.name.lastIndexOf('.'));
    };
    AttachmentControl.prototype.validateFileType = function (extension) {
        return this.validExtensions.includes(extension);
    };
    AttachmentControl.prototype.validateFileNameExists = function (name) {
        return name && name.length > 0;
    };
    AttachmentControl.prototype.validateFileSize = function (file) {
        return file.size <= this.maxSize;
    };
    //getFileNameFromPath(path: string) {
    //  return path.slice(path.lastIndexOf("/") + path.lastIndexOf("\\") + 2);
    //}
    AttachmentControl.prototype.inputFile = function (newFile, oldFile) {
        if (newFile && oldFile) {
            // Start upload
            if (newFile.active && newFile.active !== oldFile.active) {
                // Before sending file to server
                this.$emit('start-upload');
            }
            if (newFile.error !== oldFile.error) {
                // There was an error uploading the file to storage
                Notification.error(this, this.$t("Attachment.Error"));
                this.clearAttachment();
                this.$emit('stop-upload');
            }
            if (newFile.success !== oldFile.success) {
                var responseString = newFile.response;
                if (responseString.indexOf('<!') != -1) {
                    // There was an error uploading the file to storage
                    Notification.error(this, this.$t("Attachment.Error"));
                    this.clearAttachment();
                    this.$emit('stop-upload', this.inputId);
                }
                else {
                    // File was uploaded successfully
                    if (this.notifyonuploadedsuccess) {
                        Notification.success(this, this.$t("Attachment.Success"));
                    }
                    this.currentFile = newFile.name;
                    this.$emit('stop-upload', this.inputId);
                    this.$emit('added-attachment', newFile.response);
                }
            }
        }
        if (!newFile && oldFile) {
            // Remove file - Do nothing but clear the given file
            this.clearAttachment();
        }
        // Start document upload to server automatically
        if (Boolean(newFile) !== Boolean(oldFile) || oldFile.error !== newFile.error) {
            if (!this.uploadComponent.active) {
                this.uploadComponent.active = true;
            }
        }
    };
    AttachmentControl.prototype.deleteAttachment = function () {
        if (confirm(this.$i18n.t("Attachment.Confirmation").toString())) {
            this.clearAttachment();
            this.$emit('deleted-attachment', this.inputId);
        }
    };
    AttachmentControl.prototype.clearAttachment = function () {
        this.uploadComponent.clear();
        this.currentFile = null;
    };
    var _a;
    __decorate([
        Prop(Object),
        __metadata("design:type", typeof (_a = typeof AttachmentSettings !== "undefined" && AttachmentSettings) === "function" ? _a : Object)
    ], AttachmentControl.prototype, "settings", void 0);
    __decorate([
        Prop({ type: Array, default: function () { return []; } }),
        __metadata("design:type", Array)
    ], AttachmentControl.prototype, "allowedExtensions", void 0);
    __decorate([
        Prop(String),
        __metadata("design:type", String)
    ], AttachmentControl.prototype, "inputId", void 0);
    __decorate([
        Prop(Boolean),
        __metadata("design:type", Boolean)
    ], AttachmentControl.prototype, "required", void 0);
    __decorate([
        Prop(String),
        __metadata("design:type", String)
    ], AttachmentControl.prototype, "value", void 0);
    __decorate([
        Prop({ type: Boolean, default: true }),
        __metadata("design:type", Boolean)
    ], AttachmentControl.prototype, "notifyonuploadedsuccess", void 0);
    AttachmentControl = __decorate([
        Component({
            name: "AttachmentControl",
            components: {
                FileUpload: FileUpload
            }
        })
    ], AttachmentControl);
    return AttachmentControl;
}(Mixins(Savable)));
export default AttachmentControl;
